import React, { useState, useEffect } from 'react'
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import Alert from 'react-bootstrap/esm/Alert';
import { Navigate } from "react-router-dom";
import InputGroup from 'react-bootstrap/InputGroup'; // Import InputGroup for combining input with button



const Login = (props) => {
    const [validated, set_Validated] = useState(false);
    const [showPassword, setShowPassword] = useState(false); // State to manage password visibility
    const [loginError, setLoginError] = useState('')
    const [form_Data, set_Form_Data] = useState({
        email: "gautam@gmail.com",
        password: "g1234567",
    });

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    useEffect(() => {
        const token = localStorage.getItem('jwt');
        if (token ){
            props.setLogin(true)
            const tokenArray = token.split('.')
            const tokenPayload = JSON.parse(atob(tokenArray[1]))
            console.log(tokenPayload['sub'])
            props.setUser(tokenPayload['sub'])
        }
    }, [])
    // const navigate = useNavigate()

    const submitFn = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        set_Validated(true);
        console.log(form_Data)
        console.log(props.isLoggedIn)
        setLoginError("")
        fetch("https://easytasks.in/employee/login", {
            method: "POST",
            mode: "cors",
            headers: { "Accept": "application/json", "Content-Type": "application/json" },
            body: JSON.stringify(form_Data),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.status_code == 401)
                    setLoginError(data.msg)
                else {
                    props.setLogin(true)
                    localStorage.setItem('jwt', data.access_token)
                    const tokenArray = data.access_token.split('.')
                    const tokenPayload = JSON.parse(atob(tokenArray[1]))
                    console.log(tokenPayload['sub'])
                    props.setUser(tokenPayload['sub'])
                }
            })
            .catch((error) => { alert("Error") });
    };

    const chngFn = (event) => {
        const { name, value } = event.target;
        set_Form_Data({
            ...form_Data,
            [name]: value,
        });
    };

    // if (props.isLoggedIn) {
    //     return (
    //         <Navigate to="/employee/list" replace={true} />
    //     )
    // }
    if (props.isLoggedIn) {
        if (props.position === 'Manager') {
            return <Navigate to="/tasks/list" replace={true} />;
        } else if (props.position === 'Employee', 'Middle Management') {
            return <Navigate to="/tasks/list" replace={true} />;
        }
    }
    return (
        <Container>
            <Row className="justify-content-md-center">
                <Col xs lg="5" >
                    <h2 className='my-5'><b>WELCOME ! Please log in.</b></h2>
                </Col>
            </Row>
            <Row className="justify-content-md-center">
                <Col xs lg="5">
                    <Form validated={validated} onSubmit={submitFn}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>Email address</Form.Label>
                            <Form.Control
                                placeholder="name@example.com"
                                type="email"
                                name="email"
                                value={form_Data.email}
                                onChange={chngFn}
                                required
                                isInvalid={
                                    validated &&
                                    !/^\S+@\S+\.\S+$/.test(form_Data.email)

                                }
                            />
                            <Form.Text className="text-muted">
                                We'll never share your email with anyone else.
                            </Form.Text>
                            <Form.Control.Feedback type="invalid">
                                Please enter a valid email address.
                            </Form.Control.Feedback>
                        </Form.Group>

                        {/* <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Password</Form.Label>
                            <Form.Control
                                name="password"
                                type="password"
                                placeholder="Password"
                                value={form_Data.password}
                                onChange={chngFn} 
                                />
                        </Form.Group> */}
                        
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Password</Form.Label>
                            <InputGroup>
                             <Form.Control
                                type={showPassword ? 'text' : 'password'}
                                name="password"
                                placeholder="Password"
                                value={form_Data.password}
                                onChange={chngFn} 
                                // pattern="^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$"
                                required
                                isInvalid={
                                    validated &&
                                    !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(form_Data.password)
                                }
                                />
                                <Button variant="outline-secondary" onClick={togglePasswordVisibility}>
                                {showPassword ? 'Hide' : 'Show'}
                                </Button>
                                <Form.Control.Feedback type="invalid">
                                Please enter a valid password 
                                </Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>

                        {/* <Form.Group className="mb-3" controlId="formBasicPassword">
                            
                        <Form.Label>Password</Form.Label>
                        <InputGroup>
                            <Form.Control
                                type={showPassword ? 'text' : 'password'}
                                name="password"
                                placeholder="Password"
                                value={form_Data.password}
                                onChange={chngFn}
                                required
                                isInvalid={
                                    validated && 
                                    !/^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/.test(form_Data.password)
                                }
                            />
                            <Button variant="outline-secondary" onClick={togglePasswordVisibility}>
                                {showPassword ? 'Hide' : 'Show'}
                            </Button>
                            <Form.Control.Feedback type="invalid">
                                Password must be at least 8 characters long and include at least one letter and one number.
                            </Form.Control.Feedback>
                        </InputGroup>
                    </Form.Group> */}

                    
                        
                        <Button variant="primary" type="submit">
                            Log In
                        </Button>
                    </Form>
                    {/* new code */}
                    {/* {<><br /><Alert key={"info"} variant={"info"}>{props.isLoggedIn.toString()}</Alert></>} */}
                    {loginError != "" ? <><br /><Alert key={"danger"} variant={"danger"}>{loginError}</Alert></> : <></>}
                </Col>
            </Row>
        </Container>
    )
}

export default Login


